<template>
    <div class="form section-d dealer-form">
        <div class="section-subhead">
            <i v-if="locked" class="fa fa-lock" style="padding: 0 0.25em 0 0; cursor: pointer;" @click="showLockedReason()"></i>
			Section D - Transferee / Buyer Recertification
        </div>
        <div class="section-d-detail">
			<p v-if="spanishLanguage">Si la transferencia del arma(s) de fuego se lleva a cabo en un día diferente de la fecha en que el adquiriente/comprador firmó la sección B, el adquiriente/ comprador debe completar la sección D inmediatamente antes de la transferencia del arma(s) de fuego.</p>
            <p v-else>If the transfer of the firearm(s) takes place on a different day from the date that the transferee/buyer signed Section B, the transferee/buyer must complete Section D immediately prior to the transfer of the firearm(s).</p>
			<p v-if="spanishLanguage"><strong>Yo certifico que todas mis respuestas en la Sección B de esta forma sigue siendo verdaderas, correctas y completas.</strong></p>
            <p v-else><strong>I certify that all of my responses in Section B of this form are still true, correct, and complete.</strong></p>
			<div class="section-d-section two-one-columns">
				<div>
					<label v-if="spanishLanguage">Firma del adquiriente/comprador</label>
					<label v-else ref="buyer_recertification_signature">Transferee’s / Buyer’s Signature</label>
					<div v-if="form.form_data.section_d.buyer_recertification_signature" style="margin: 1em 0 0 1em;">
						<img class="signature" :src="form.form_data.section_d.buyer_recertification_signature">
						<div v-if="correcting" style="margin: 1em 0 0 0;">
								<div class="button neutral inline" @click="form.form_data.section_d.buyer_recertification_signature = ''">Clear Signature</div>
							</div>
					</div>
					<div v-else style="margin: 1em 0 0 0;">
						<signature-inputs v-model="form.form_data.section_d.buyer_recertification_signature" :spanishLanguage="spanishLanguage" :key="'si_' + spanishLanguage" :enableSignOnScreen="enableSignOnScreen" />
					</div>
				</div>
				<div>
					<label v-if="spanishLanguage">Fecha de certificación</label>
					<label v-else ref="buyer_recertification_date">Certification Date</label>
					<div v-if="!correcting" v-show="$route.path.indexOf('customer') > -1">
						<checkbox v-if="spanishLanguage" v-model="acceptToday" label="Marque aquí para aceptar la fecha de hoy" style="margin: 1em 0;" />
						<checkbox v-else v-model="acceptToday" label="Check here to accept today's date" style="margin: 1em 0;" />
					</div>
					<date-input v-if="correcting" v-model="form.form_data.section_d.buyer_recertification_date" />
					<input v-else type="text" v-model="form.form_data.section_d.buyer_recertification_date" style="width: 13em;" readonly />
					<div v-if="transferDateBanner" class="note" :style="{ color: 'red', fontWeight: 'bold' }">More than 30 days have passed since the initial NICS transmission date. If this transfer requires a NICS check, it should not be completed. Speak with a staff member before proceeding.</div>
				</div>
			</div>
		</div>

		<div v-if="locked" style="position: absolute; top: 2.5em; left: 0; width: 100%; height: 100%; cursor: not-allowed;" @click="showLockedReason()"></div>

		<message-modal v-if="message" :message="message" :loading="saving" :errorStatus="messageStatus" :timeout="messageTimeout" @dismiss="message = ''" />

	</div>
</template>

<script>
import BinaryToggle from '@/components/BinaryToggle.vue'
import CDSDateInput from '@/components/DateInput.vue'
import Checkbox from '@/components/Checkbox.vue'
import SignatureInputs from '@/components/SignatureInputs.vue'
export default {
	name: 'form4473-section-d',
	props: ['form', 'spanishLanguage', 'locked', 'enableSignOnScreen', 'correcting'],
	components: {
        'binary-toggle': BinaryToggle,
		'date-input': CDSDateInput,
		'checkbox': Checkbox,
		'signature-inputs': SignatureInputs
	},
	data() {
		return {
			loading: false,
			today: '',
			todayFormatted: '',
			saving: false,
			message: '',
			messageStatus: '',
			messageTimeout: 0,
			acceptToday: false
		}
	},
	computed: {
		transferDateBanner() {
			return this.$moment(new Date()).diff(this.$moment(this.form.form_data.section_c.nics_initial_response_date), 'days') > 30
		}
	},
	created() {
		let theDate = new Date()
		this.today = theDate.getFullYear() + '-' + (theDate.getMonth() + 1).toString().padStart(2,'0') + '-' + theDate.getDate().toString().padStart(2,'0')
		this.todayFormatted = (theDate.getMonth() + 1).toString().padStart(2,'0') + '/' + theDate.getDate().toString().padStart(2,'0') + '/' + theDate.getFullYear()
	},
	watch: {
		acceptToday (newVal) {
			if (newVal) {
				this.form.form_data.section_d.buyer_recertification_date = this.todayFormatted
			} else {
				this.form.form_data.section_d.buyer_recertification_date = ''
			}
		}
	},
    methods: {
		showLockedReason() {
			this.message = 'Section D is locked because<br>'
			if (this.form.internal_use_only) {
				this.message += 'it can only be corrected <a href="/dashboard/logbooks/customer-4473" target="_blank"><b><u>in the Kiosk</u></b></a>.'
			} else if (this.form.moved_to_ffl_log_book_form_id) {
				this.message += 'it is a previous version of a corrected form.'
			} else if (this.form.form_data.section_e.seller_signature) {
				this.message += 'Section E has been signed.'
			} else if (this.form.form_data.section_d.buyer_recertification_signature) {
				this.message += 'it has been signed by the Transferee / Buyer.'
			} else if (this.form.section_completed < 'B') {
				this.message += 'Section B has not been completed by the Transferee / Buyer.'
			} else {
				this.message += 'it must be completed <a href="/dashboard/logbooks/customer-4473" target="_blank"><b><u>in the Kiosk</u></b></a>.'
			}
			this.messageStatus = 'alert'
		},
		validateSection() {
			let data = this.form.form_data.section_d
			let errorMessage = ''
			if (!data.buyer_recertification_signature) {
				errorMessage = 'Signature is required.'
			}
			if (!errorMessage && !data.buyer_recertification_date) {
				errorMessage = 'Certification date is required.'
			}
			return errorMessage
		}
	}
}
</script>
